import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Card, Col, Input, Row, Layout, notification } from 'antd'

import Navbar from '../components/Navbar'
import WebcamPanel from '../components/WebcamPanel'
import Footer from '../components/Footer'
import requests from '../services/requests'

const { Content } = Layout

const INITIAL_STATE = {
  captured: false,
  loading: false,
  event: null,
  bibId: '',
  faceImage: '',
  runner: null,
}

class Check extends Component {
  state = INITIAL_STATE
  componentWillMount() {
    this.setState({ event: this.props.event })
  }
  handleWebcam(image) {
    this.setState({ faceImage: image })
  }
  handleCapture() {
    this.setState({ captured: true })
  }
  handleReCapture() {
    this.setState(state => ({ ...INITIAL_STATE, event: state.event }))
  }
  handleInputChange(e) {
    this.setState({ bibId: e.target.value })
  }
  async check(i, personId) {
    this.setState({ loading: true })
    const {
      event,
      faceImage,
      bibId,
    } = this.state
    const body = {
      eventId: event.id,
      bibId,
      faceImage,
    }
    try {
      const runner = await requests.post(`/event/${event.id}/check`, body)
      this.setState({ loading: false, runner })
    } catch (err) {
      console.error(err)
      this.setState({ loading: false })
      notification.error({
        message: 'Check fail',
        description: '',
      })
    }
  }
  render() {
    const width = this.state.runner && this.state.runner.card ? 8 : 12
    return (
      <Layout>
        <Navbar event={this.state.event} selected="3" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            {!this.state.runner && (
              <Row gutter={24}>
                <Col span={16} style={{ textAlign: 'center' }}>
                  <WebcamPanel
                    captured={this.state.captured}
                    previewImage={this.state.faceImage}
                    handleWebcam={image => this.handleWebcam(image)}
                    handleCapture={() => this.handleCapture()}
                    handleReCapture={() => this.handleReCapture()}
                  />
                </Col>
                <Col span={8} style={{ overflowY: 'auto' }}>
                  <Card>
                    <p>Bib ID: <Input type="text" name="bibId" value={this.state.bibId} onChange={e => this.handleInputChange(e)} /></p>
                    <Button type="primary" onClick={() => this.check()} style={{ float: 'right' }} disabled={!this.state.captured || this.state.bibId === '' || this.state.loading}>Check</Button>
                  </Card>
                </Col>
              </Row>
            )}
            {this.state.runner && (
              <div>
                <Row gutter={8}>
                  {this.state.runner.card && this.state.runner.card.image && (
                    <Col span={width}>
                      <Card cover={<img src={this.state.runner.card.image} alt="" style={{ width: '100%' }} />}>
                        <Card.Meta title="Card ID" />
                      </Card>
                    </Col>
                  )}
                  <Col span={width}>
                    <Card cover={<img src={this.state.runner.register.image} alt="" style={{ width: '100%' }} />}>
                      <Card.Meta title="Register" />
                    </Card>
                  </Col>
                  <Col span={width}>
                    <Card cover={<img src={this.state.runner.check.image} alt="" style={{ width: '100%' }} />}>
                      <Card.Meta title="Check" />
                    </Card>
                  </Col>
                  <Col span={24} style={{ textAlign: 'center' }}>
                    <Button type="danger" size="large" onClick={this.handleReCapture} style={{ marginTop: '1em' }}>Re capture</Button>
                  </Col>
                </Row>
              </div>
            )}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
Check.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    personGroupId: PropTypes.string,
  }),
}
Check.defaultProps = {
  event: {},
}

export default Check



// WEBPACK FOOTER //
// ./src/pages/Check.js